<template>
  <div class="col-12 bg-white-primary mx-auto">
    <div
      class="d-flex flex-column flex-md-row justify-content-md-start align-items-center border-bottom mb-1 mx-0 ps-0 ps-md-3 pe-0"
    >
      <div class="size-16 fw-bold text-center pt-4 pb-2 pb-md-4 ps-0 ps-md-2">自己PR</div>
    </div>
    <div class="row mx-3 py-4">
      <div class="input-group row">
        <div class="col-12 pe-0">
          <label class="form-label size-12" for="">自己PR</label>
          <Field
            v-slot="{ field, errors }"
            v-model="skillStore.self_description"
            name="self_description"
          >
            <textarea
              class="form-control bg-silver-primary input-primary size-14 border-0"
              rows="5"
              :class="{ 'is-invalid': !!errors.length }"
              placeholder="これまでの実績やご自身の強みなど、自己PRをご入力ください。"
              v-bind="field"
            ></textarea>
            <div
              class="d-flex justify-content-end mt-2 size-10"
              :class="skillStore.self_description?.length > 2000 ? 'text-danger' : 'text-black-50'"
            >
              {{ skillStore.self_description?.length || 0 }}
              /2000（最大文字数2000文字）
            </div>
            <ErrorMessage name="self_description" class="invalid-feedback" />
          </Field>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Field, ErrorMessage } from 'vee-validate';
import { useSkillStore } from '@/stores/resume-candidate/Skill.store';

const skillStore = useSkillStore();
</script>
